import { BASE_URL_AUTH } from "../../apis/configs/axiosConfig";


export const AUTH_CONFIG = {
  // TEST: login-hub1.skypad.biz  |  PROD: login-hub.skypad.biz (swap at prod deploy)
  domain: 'login-hub.skypad.biz',
  // TEST: MLp8MkpiaxNNp321HLzdP9tDAbJqkCSf  |  PROD: hn3r1Pc7ObGZtzVpeh9hCdsdhGoH335j (swap at prod deploy)
  clientId: 'hn3r1Pc7ObGZtzVpeh9hCdsdhGoH335j',
  callbackUrl: BASE_URL_AUTH,
  baseUrl: BASE_URL_AUTH,
  // TEST: omit  |  PROD: LDAP-Connection-GCP (swap at prod deploy)
  basicConnection: 'LDAP-Connection-GCP',
}
